import Header from '@cimpress-technology/react-platform-header';
import React from 'react';
import autoBind from 'react-autobind';

import { auth, login, logout } from '../../utils/auth';
import { Link } from 'react-router-dom';
import LayoutSettings from './LayoutSettings';

class AppHeader extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  render() {
    // Only render settings if user has logged in
    let defatultTo = '/';
    const isRedirectedFromContractV2 = window.location.pathname.includes('&&!!');
    const settingsLink = auth.isLoggedIn() && { id: 'contractV1AppLinks', content: <LayoutSettings /> };
    if (isRedirectedFromContractV2) {
      defatultTo = process.env.REACT_APP_CONTRACT_MANAGER_V2_URL;
    }
    return (
      <Header
        responsive
        appTitle={
          defatultTo === '/' ? (
            <Link to={'/'}>
              <h2>Contract Manager</h2>
            </Link>
          ) : (
            <a href={defatultTo}>
              <h2>Contract Manager</h2>
            </a>
          )
        }
        appLinks={[settingsLink]}
        profile={auth.getProfile()}
        onLogInClicked={login}
        onLogOutClicked={logout}
        isLoggedIn={auth.isLoggedIn()}
        accessToken={auth.getAccessToken()}
      />
    );
  }
}

export default AppHeader;
